// extracted by mini-css-extract-plugin
module.exports = {"searchWrapperDefault":"search-wrapper-module--searchWrapperDefault--2Coo8"};